export default __webpack_public_path__ + "static/media/words-mark.0f4368db.png";